import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataProduct(params) {
	return client.get("api/product/data", {
		params: params,
	});
}

function exportProduct(params) {
	return client.get("api/product/export", {
		params: params,
	});
}

function addProduct(params) {
	return client.post("api/product/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateProduct(params) {
	return client.post("api/product/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteProduct(params) {
	return client.post("api/product/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusProduct(params) {
	return client.post("api/product/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataProductCategory(params) {
	return client.get("api/product-category/data", {
		params: params,
	});
}

function addProductCategory(params) {
	return client.post("api/product-category/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateProductCategory(params) {
	return client.post("api/product-category/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteProductCategory(params) {
	return client.post("api/product-category/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusProductCategory(params) {
	return client.post("api/product-category/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getDataProductStock() {
	return client.get("api/product-stock/data");
}

function getDataProductStockLog() {
	return client.get("api/product-stock-log/data");
}

function getDataProductStockTransfer() {
	return client.get("api/product-stock-transfer/data");
}

function getOptionProductUnit() {
	return client.get("api/options/product-unit");
}

function getOptionProductCategory() {
	return client.get("api/options/product-category");
}

function getOptionProductConvert() {
	return client.get("api/options/product-convert");
}

function getDataConvertProduct(params) {
	return client.get("api/product/convert-product-data", {
		params: params,
	});
}

function getDataConvertProductWarehouse(params) {
	return client.get("api/product/convert-product-data-all", {
		params: params,
	});
}

function exportConvertProduct(params) {
	return client.get("api/product/export-convert-product", {
		params: params,
	});
}

function exportConvertProductWarehouse(params) {
	return client.get("api/product/export-convert-product-all", {
		params: params,
	});
}

function convertProduct(params) {
	return client.post("api/product/convert-product", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function uploadImage(params) {
	return client.post('api/product/image', params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function getOptionSerialType() {
	return client.get("api/options/serial_type");
}

export default {
	getDataProduct,
	exportProduct,
	addProduct,
	updateProduct,
	deleteProduct,
	statusProduct,
	getDataProductCategory,
	addProductCategory,
	updateProductCategory,
	deleteProductCategory,
	statusProductCategory,
	getDataProductStock,
	getDataProductStockLog,
	getDataProductStockTransfer,
	getOptionProductUnit,
	getOptionProductCategory,
	getOptionProductConvert,
	getDataConvertProduct,
	getDataConvertProductWarehouse,
	exportConvertProduct,
	exportConvertProductWarehouse,
	convertProduct,
	uploadImage,
	getOptionSerialType
};